"use client";

import { Anchor, Button, getLocaleAsset } from "@tosize/ui";
import Image from "next/image";
import { lato } from "~/styles/font";
import "~/styles/globals.css";

export default function NotFound() {
	return (
		<html lang="en" className={lato.variable}>
			<body className="flex min-h-dvh flex-col items-center justify-center gap-8 md:flex-row">
				<div className="prose">
					<h1 className="font-extrabold text-9xl text-primary-medium">404</h1>
					<h2>Page not found</h2>

					<ol>
						<li>
							<Button variant="link" onClick={() => history.back()}>
								Go back
							</Button>
						</li>
						<li>
							<Anchor href="/">Go home</Anchor>
						</li>
					</ol>
				</div>

				<Image
					priority
					className="max-h-48 w-auto"
					src={getLocaleAsset("Karakters/hans_search.png")}
					width={801}
					height={651}
					alt=""
				/>
			</body>
		</html>
	);
}
